module.exports = __webpack_public_path__ + "media/images/facebook-color-small-6c317342d92e3dabfab5847b45255b62.png";